import React from 'react';
export function Guarantee() {
  return <section className="bg-white text-navy py-12" data-id="element-96">
      <div className="max-w-md mx-auto px-4 text-center" data-id="element-97">
        <div className="text-5xl mb-4" data-id="element-98">🛡️</div>
        <h2 className="text-2xl font-bold mb-4" data-id="element-99">
          Garantía 7 días — Sin preguntas
        </h2>
        <p className="text-[15px] text-gray-700 leading-relaxed mb-6" data-id="element-100">
          Abrís el sistema. Lo usás en tu próxima clase. Si en 7 días no es lo
          que esperabas, te devolvemos el 100% sin formularios, sin drama.
        </p>
        <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-bold" data-id="element-101">
          <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-102"></span>
          Tasa de devoluciones: menos del 1%.
        </div>
      </div>
    </section>;
}